import {
    Tune as Adjustments,
    Assessment,
    GridOn,
    Security,
    VerifiedUser
} from "@material-ui/icons";
import {
    Box,
    Button,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    LinearProgress,
    Slide,
    Typography
} from "@material-ui/core";
import React from "react";
import { orgId, getOrg } from "./utils/auth";

const quickViewMessages = {
    accounting: {
        message:
            `Set up general ledger accounts to customize account mapping, ` +
            `and connect to your accounting system to automatically post journal entries.`,
        link: "https://www.chargebee.com/docs/revrec/journal-account-mapping.html"
    },
    sync: {
        message:
            `Sync data automatically or manually between RevRec and your third-party systems. ` +
            `You can sync sales contract data from your CRM, and invoices from your billing software and mobile stores. `,
        link: "https://www.chargebee.com/docs/revrec/data-overview.html"
    },
    "configure revrec": {
        message:
            `Configure <u><a href="https://www.chargebee.com/docs/revrec/journal-posting-closing.html" style="color: white;padding-left: 2px;text-decoration-line:none" target="_black"> accounting close</a></u>, ` +
            `<u><a href="https://www.chargebee.com/docs/revrec/multi-currency.html" style="color: white;padding-left: 2px;text-decoration-line:none" target="_black">multi-currency</a></u> and ` +
            `<u><a href="https://www.chargebee.com/docs/revrec/standalone-selling-price.html" style="color: white;padding-left: 2px;text-decoration-line:none" target="_black">Journal Account Mapping fields</a></u>. `
    },
    "accounting rules": {
        message:
            `Configure ` +
            `<u><a href="https://www.chargebee.com/docs/revrec/configuring-revenue-rules.html" style="color: white;padding-left: 2px;text-decoration-line:none" target="_black">accounting rules</a></u> and ` +
            `<u><a href="https://www.chargebee.com/docs/revrec/expense-recognition.html" style="color: white;padding-left: 2px;text-decoration-line:none" target="_black"> expense recognition rules.</a></u>`
    }
};

const isAdjustmentsEnabled = (orgConfig) => {
    if (orgConfig) {
        const adjustments = orgConfig.find(
            (cfg) => cfg.id == "properties/manualAdjustmentsEnabled"
        );

        return adjustments && adjustments.value == true;
    }

    return false;
};

/** Accounting Central menu items */
const acMonthlyCloseMenu = (props) => {
    const toReturn = [
        {
            id: "Data Validation",
            label: "Data Validation",
            // leadingIcon: 'check-line',
            linkTo: `ac/${orgId()}/errors`
        },
        {
            id: "Closing Reports",
            label: "Closing Reports",
            // leadingIcon: 'grid-2x2-check',
            linkTo: `ac/${orgId()}/closing-reports`
        },
        {
            id: "Post Journals",
            label: "Post Journals",
            // leadingIcon: 'list-checks',
            linkTo: `ac/${orgId()}/journal-posting`
        },
        {
            id: "Close Period",
            label: "Close Period",
            // leadingIcon: 'calendar-check',
            linkTo: `ac/${orgId()}/period-close`
        }
    ];

    return toReturn;
};

const acReportsMenu = (props) => {
    const toReturn = [
        {
            title: "Billing Transaction Recon",
            icon: <GridOn />,
            getHref: () => `/ac/${orgId()}/billing-period-recon`,
            visible: (org) => (org ? true : false)
        },
        {
            title: "Payment Transaction Recon",
            icon: <GridOn />,
            getHref: () => `/ac/${orgId()}/transaction-period-recon`,
            visible: (org) => (org ? true : false)
        },
        {
            title: "Transaction to Journal Recon",
            icon: <GridOn />,
            getHref: () => `/ac/${orgId()}/transactions-to-journal-recon`,
            visible: (org) => (org ? true : false)
        },
        {
            title: "Audit Trail",
            icon: <VerifiedUser />,
            getHref: () => `/ac/${orgId()}/audit`,
            visible: (org) => (org ? true : false)
        },
        {
            title: "Security Events",
            icon: <Security />,
            getHref: () => `/ac/${orgId()}/security`,
            visible: (org) => (org ? true : false)
        }
    ];

    return toReturn;
};

const acConfigurationMenu = (props) => {
    const toReturn = [
        {
            id: "Accounting",
            label: "Accounting",
            // leadingIcon: 'square-library',
            linkTo: `ac/${orgId()}/accounting-settings`
        },
        {
            id: "Team Members",
            label: "Team Members",
            // leadingIcon: 'users',
            linkTo: `ac/${orgId()}/team`
        }
    ];

    return toReturn;
};

const acAdminMenu = (props) => {
    return [
        {
            id: "Merchants",
            label: "Merchants",
            // leadingIcon: "arrow-right",
            linkTo: `ac/admin/merchants`
        },
        {
            id: "Processes",
            label: "Processes",
            // leadingIcon: "arrow-right",
            linkTo: `ac/admin/processes`
        },
        {
            id: "Admin Actions",
            label: "Admin Actions",
            // leadingIcon: "arrow-right",
            linkTo: `ac/admin/action`
        }
    ];
};

const generateAcMenu = (props) => {
    const { currentUser } = props;

    const acMenuItems = [
        {
            id: "Home",
            label: "Home",
            leadingIcon: "gauge",
            linkTo: `ac/${orgId()}/`
        },
        {
            id: "Customers",
            label: "Customers",
            leadingIcon: "users",
            linkTo: `ac/${orgId()}/customers`
        },
        {
            id: "Accounts Receivable",
            label: "Accounts Receivable",
            leadingIcon: "layout-list",
            linkTo: `ac/${orgId()}/accountsReceivable`
        },
        {
            id: "Payments",
            label: "Payments",
            leadingIcon: "dollar-sign",
            linkTo: `ac/${orgId()}/cash`
        },
        {
            id: "Data Sync",
            label: "Data Sync",
            leadingIcon: "refresh-ccw",
            linkTo: `ac/${orgId()}/pages/sync`
        },
        {
            id: "Monthly Close",
            label: "Monthly Close",
            leadingIcon: "calendar",
            subItems: acMonthlyCloseMenu()
        },
        ,
        ...(props.currentOrganization.disableReporting
            ? []
            : [
                  {
                      id: "Reports",
                      label: "Reports",
                      leadingIcon: "trending-up",
                      linkTo: `ac/${orgId()}/reports`
                  }
              ]),
        {
            id: "Settings",
            label: "Settings",
            leadingIcon: "settings",
            linkTo: `ac/${orgId()}/settings`,
            subItems: acConfigurationMenu()
        },
        ...(currentUser && currentUser.superAdminLevel > 0
            ? [
                  {
                      id: "Admin",
                      label: "Admin",
                      leadingIcon: "user-cog",
                      subItems: acAdminMenu()
                  }
              ]
            : [])
    ];
    return acMenuItems;
};

const getJsxElement = (key) => {
    return (
        <Grid container spacing={0} justify={"center"} alignItems={"center"}>
            <Grid item xs={12}>
                <div
                    style={{
                        paddingBottom: "20px"
                    }}>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: quickViewMessages[key].message
                        }}></p>
                    <br />
                    {quickViewMessages[key].link && (
                        <>
                            <u>
                                <a
                                    size="medium"
                                    variant="outlined"
                                    color="primary"
                                    href={quickViewMessages[key].link}
                                    target="_black">
                                    Learn More
                                </a>
                            </u>
                        </>
                    )}
                </div>
                <div>
                    <Button
                        size="medium"
                        variant="contained"
                        style={{ color: "white", backgroundColor: "#317295ff" }}
                        onClick={(e) => window.open("mailto:ar@chargebee.com")}>
                        Contact Us
                    </Button>
                </div>
            </Grid>
        </Grid>
    );
};

const generateRevRecMenu = (props, disableActionsForQuickView) => {
    const expenseConfig =
        props.orgConfig &&
        props.orgConfig.find((cfg) => cfg.id == "properties/expense-enabled");
    const expenseEnabled = expenseConfig && expenseConfig.value == true;
    const { currentUser, rrEnabled } = props;
    const _revrecMenuItems = [
        {
            id: "Home",
            label: "Home",
            leadingIcon: "gauge",
            linkTo: `dashboards`
        },
        {
            id: "Customers",
            label: "Customers",
            leadingIcon: "users",
            linkTo: `pages/customers`
        },
        {
            id: "Sales Order",
            label: "Sales Order",
            leadingIcon: "layout-list",
            linkTo: `pages/sales`
        },
        ...(expenseEnabled
            ? [
                  {
                      id: "Expense",
                      label: "Expense",
                      leadingIcon: "circle-dollar-sign",
                      linkTo: `pages/expenses`
                  }
              ]
            : []),
        {
            id: "Products",
            label: "Products",
            leadingIcon: "grip",
            linkTo: `products`
        },
        ...((!isAdjustmentsEnabled(props.orgConfig) && [
            {
                id: "Journal Accounts",
                label: "Accounting",
                leadingIcon: "album",
                linkTo: `journalaccounts`,
                disabled: disableActionsForQuickView || false,
                tooltip:
                    (disableActionsForQuickView &&
                        getJsxElement("accounting")) ||
                    null
            }
        ]) || [
            {
                id: "Journal Accounts",
                label: "Accounting",
                leadingIcon: "album",
                linkTo: `journalaccounts`,
                disabled: disableActionsForQuickView || false,
                tooltip:
                    (disableActionsForQuickView &&
                        getJsxElement("accounting")) ||
                    null
            },
            {
                id: "Adjustments",
                label: "Adjustments",
                leadingIcon: "file-spreadsheet",
                linkTo: `adjustments`
            }
        ]),
        {
            id: "Sync",
            label: "Sync",
            leadingIcon: "refresh-ccw",
            linkTo: `pages/sync`,
            disabled: disableActionsForQuickView || false,
            tooltip:
                (disableActionsForQuickView && getJsxElement("sync")) || null
        },
        ...(props.currentOrganization.disableReporting
            ? []
            : [
                  {
                      id: "Reports",
                      label: "Reports",
                      leadingIcon: "trending-up",
                      linkTo: `mstr-native-report-parent`
                  }
              ]),
        {
            id: "Settings",
            label: "Settings",
            leadingIcon: "settings",
            subItems: [
                {
                    id: "Configure RevRec",
                    label: "Configure RevRec",
                    // leadingIcon: "arrow-right",
                    linkTo: `organization/settings?tab=1`,
                    disabled: disableActionsForQuickView || false,
                    tooltip:
                        (disableActionsForQuickView &&
                            getJsxElement("configure revrec")) ||
                        null
                },
                {
                    id: "Accounting Rules",
                    label: "Accounting Rules",
                    // leadingIcon: "arrow-right",
                    linkTo: `esp?tab=0`,
                    disabled: disableActionsForQuickView || false,
                    tooltip:
                        (disableActionsForQuickView &&
                            getJsxElement("accounting rules")) ||
                        null
                },
                {
                    id: "Team Members",
                    label: "Team Members",
                    // leadingIcon: "arrow-right",
                    linkTo: `organization?tab=0`
                }
            ]
        },
        ...(currentUser && currentUser.superAdminLevel > 0
            ? [
                  {
                      id: "Admin",
                      label: "Admin",
                      leadingIcon: "user-cog",
                      subItems: [
                          {
                              id: "Merchants",
                              label: "Merchants",
                              linkTo: `admin/`
                              // leadingIcon: "arrow-right"
                          },
                          {
                              id: "Processes",
                              label: "Processes",
                              // leadingIcon: "arrow-right",
                              linkTo: `admin/processes`
                          },
                          {
                              id: "Actions",
                              label: "Actions",
                              // leadingIcon: "arrow-right",
                              linkTo: `admin/action`
                          },
                          {
                              id: "Utilities",
                              label: "Utilities",
                              // leadingIcon: "arrow-right",
                              linkTo: `admin/utilities`
                          }
                      ]
                  }
              ]
            : [])
    ];
    return _revrecMenuItems;
};
export const getMenuItems = (props, menuProps, disableActionsForQuickView) => {
    const { currentOrganization, rrEnabled, isACSite } = props;
    let items;
    if (
        (menuProps && menuProps.space == "ac") ||
        window.location.pathname.includes("/ac/") ||
        isACSite ||
        rrEnabled == false
    ) {
        items = generateAcMenu(props);
        if (
            currentOrganization.id.startsWith("6") &&
            currentOrganization.id.startsWith("7")
        ) {
            items = items.filter(
                (item) => item.id == "Home" || item.id == "Reports"
            );
        }
    } else {
        items = generateRevRecMenu(props, disableActionsForQuickView);
        if (
            currentOrganization.id.startsWith("6") &&
            currentOrganization.id.startsWith("7")
        ) {
            items = items.filter(
                (item) => item.id == "Home" || item.id == "Reports"
            );
        }
    }

    return items;
};

export const routeItems = [
    {
        title: "Profile",
        href: "/profile"
    },
    {
        title: "Dashboard",
        href: "/dashboards"
    }
];
